<script>
export default{
    computed: {
        isLogin() {
            return this.$store.state.auth.isLogin;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/mixins/Auth.vue